import _change from "swag-client-common/redux-form-actions/change";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PaymentDetailsBillingAddressForm as PaymentDetailsBillingAddressFormComponent } from './payment-details-billing-address-form';
const mapDispatchToProps = dispatch => bindActionCreators({
  resetState: () => dispatch => {
    dispatch(_change('paymentDetailsBillingAddressForm', 'state', ''));
  }
}, dispatch);
export const PaymentDetailsBillingAddressForm = connect(null, mapDispatchToProps)(PaymentDetailsBillingAddressFormComponent);